import { useEffect, useState } from 'react';

const STATUS_LABEL = { open: 'باز', contacted: 'تماس‌گرفته', closed: 'بسته' };
const NEXT = { open: 'contacted', contacted: 'closed', closed: 'open' };

export default function WaitlistPanel({ agent }) {
  const [busyRow, setBusyRow] = useState(null);

  useEffect(() => { agent.loadWaitlist(); }, [agent.loadWaitlist]); // eslint-disable-line react-hooks/exhaustive-deps

  // Guard against double-clicks racing two PATCHes for the same row, and
  // surface PATCH errors instead of silently swallowing the rejected promise.
  // Always refresh from the server in `finally` so the display reflects truth.
  const cycle = async (row) => {
    if (busyRow) return;
    setBusyRow(row.id);
    try {
      await agent.api.setWaitlistStatus(row.id, NEXT[row.status]);
    } catch (e) {
      console.error('[waitlist] cycle failed', e);
    } finally {
      await agent.loadWaitlist();
      setBusyRow(null);
    }
  };

  return (
    <div className="consultant-panel">
      {agent.waitlist.length === 0
        ? <div className="consultant-empty">لیست انتظار خالی است.</div>
        : agent.waitlist.map((w) => (
            <div className="doc-row" key={w.id}>
              <span>
                {w.name || 'بدون نام'} · <span dir="ltr">{w.phone || '-'}</span>
                <span style={{ color: '#475569' }}> · {w.lat.toFixed(4)},{w.lng.toFixed(4)}</span>
              </span>
              <button className="consultant-btn secondary" onClick={() => cycle(w)} disabled={busyRow !== null}>
                {STATUS_LABEL[w.status] || w.status}
              </button>
            </div>
          ))}
    </div>
  );
}
